/**
 * Premium page loading spinner — elegant diamond pulse.
 * Shown during Shopify page transitions, hidden once DOM is ready.
 */
(function () {
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  var overlay = document.createElement('div');
  overlay.id = 'lbj-loader';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.innerHTML =
    '<div class="lbj-loader__diamond">' +
      '<svg viewBox="0 0 40 40" width="40" height="40">' +
        '<polygon points="20,2 38,20 20,38 2,20" fill="none" stroke="#d4af37" stroke-width="1.5"/>' +
        '<polygon points="20,8 32,20 20,32 8,20" fill="none" stroke="#d4af37" stroke-width="1" opacity="0.5"/>' +
      '</svg>' +
    '</div>';

  var style = document.createElement('style');
  style.textContent =
    '#lbj-loader{position:fixed;inset:0;z-index:999998;background:rgba(0,0,0,0.02);display:flex;align-items:center;justify-content:center;' +
    'opacity:0;pointer-events:none;transition:opacity 0.3s ease;}' +
    '#lbj-loader.active{opacity:1;pointer-events:auto;}' +
    '.lbj-loader__diamond{animation:lbjLoaderSpin 2s cubic-bezier(0.45,0.05,0.55,0.95) infinite;}' +
    '.lbj-loader__diamond svg{filter:drop-shadow(0 0 6px rgba(212,175,55,0.4));}' +
    '@keyframes lbjLoaderSpin{0%{transform:rotate(0deg) scale(1);opacity:0.7}50%{transform:rotate(180deg) scale(1.15);opacity:1}100%{transform:rotate(360deg) scale(1);opacity:0.7}}' +
    '@media(prefers-reduced-motion:reduce){.lbj-loader__diamond{animation:none;}}';
  document.head.appendChild(style);
  document.body.appendChild(overlay);

  document.addEventListener('astro:before-preparation', show);
  document.addEventListener('turbo:before-visit', show);
  document.addEventListener('shopify:section:load', hide);
  window.addEventListener('pageshow', hide);

  function show() { overlay.classList.add('active'); }
  function hide() { overlay.classList.remove('active'); }

  if (document.readyState === 'loading') {
    show();
    window.addEventListener('DOMContentLoaded', function () {
      setTimeout(hide, 200);
    });
  }
})();
